import { connect } from 'react-redux';
import View from './PartnerNameView';
import {
  currentClientId,
  data2,
  isGoingForwardSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { updateData } from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_KEY } from '../PersonalInfoWorkflowConstants';
import {
  partnerFirstName,
  personalInfoSelector,
} from '../PersonalInfoWorkflowSelector';
import dirtyGraphNodesSelector from './PartnerNameSelector';


const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  partnerName: partnerFirstName(state, ownProps),
  optionIsMarried: data2(state, ownProps)(`${BACKEND_KEY}.HasPartner`) || false,
  personalInfo: personalInfoSelector(state, ownProps),
  isGoingForward: isGoingForwardSelector(state, ownProps),
  dirtyGraphNodes: dirtyGraphNodesSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => (
    dispatch(updateData(data, workflowId, clientId))
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
